import { render, staticRenderFns } from "./SpoiledPortal.vue?vue&type=template&id=f3504b72&scoped=true&"
import script from "./SpoiledPortal.vue?vue&type=script&lang=js&"
export * from "./SpoiledPortal.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledPortal.vue?vue&type=style&index=0&id=f3504b72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3504b72",
  null
  
)

export default component.exports